import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { generateFormData } from '../Utils/helpers'
import {
  API_ENDPOINTS,
  DEFAULT_PAGE_START,
  ERROR_CODE,
} from '../Utils/constants'

export default class SpaceTemplatesStore extends FetchBase {
  @observable spaceTemplatesLoader = false
  @observable spaceTemplates = []
  @observable spaceTemplatesTotal = 0
  @observable spaceTemplateLoader = false

  @observable spaceTemplateFoldersDropdownList = []
  @observable spaceTemplateDropdownList = []
  @observable spaceTemplatFoldersSearchText = ''
  @observable spaceFoldersLoader = false
  @observable spaceTemplatFoldersCurrentPage = DEFAULT_PAGE_START
  @observable spaceTemplatFoldersList = []
  @observable spaceTemplatFoldersTotal = 0
  @observable spaceTemplateFolderActionLoader = false
  @observable moveSpaceFolderByFIdLoader = false

  @observable spaceTemplateSearchText = ''
  @observable addSpaceTemplateLoader = false

  @observable importSpaceTemp = []
  @observable importSpaceTempFailures = []
  @observable importSpaceTempFromFileLoader = false

  @action.bound
  getSpaceTemplateFoldersDropdown = async (signal) => {
    try {
      let options = {}
      let response = await this.get(
        API_ENDPOINTS.GET_DROPDOWN_SPACE_TEMP_FOLDER,
        {
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        this.spaceTemplateFoldersDropdownList =
          response?.data?.spaceTemplateFolders
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getSpaceTemplateDropdown = async (spaceTemplateFolderId) => {
    try {
      this.spaceTemplateLoader = true
      let response = await this.get(API_ENDPOINTS.GET_DROPDOWN_SPACE_TEMPLATE, {
        pageLimit: 0,
        spaceTemplateFolderId: spaceTemplateFolderId,
      })
      if (response.status) {
        this.spaceTemplateDropdownList = response?.data?.spaceTemplates
        this.spaceTemplateLoader = false
        return [true, response?.data?.spaceTemplates]
      }
      return [false, undefined]
    } catch (err) {
      this.spaceTemplateLoader = false
      return [false, undefined]
    } finally {
      this.spaceTemplateLoader = false
    }
  }

  @action.bound
  setSpaceTemplateFoldersSearchText = (value = '') => {
    this.spaceTemplatFoldersSearchText = value
  }

  @action.bound
  setSpaceTemplateFoldersCurrentPage = (page = DEFAULT_PAGE_START) => {
    this.spaceTemplatFoldersCurrentPage = page
  }

  @action.bound
  getSpaceTemplateFolders = async (signal) => {
    try {
      this.spaceFoldersLoader = true
      let options = {}
      this.spaceTemplatFoldersSearchText &&
        (options['search'] = this.spaceTemplatFoldersSearchText)
      let response = await this.get(
        API_ENDPOINTS.FOLDER_SPACE_TEMPLATE,
        {
          pageNo: Math.max(this.spaceTemplatFoldersCurrentPage - 1, 0),
          ...options,
        },
        signal
      )
      if (response.status) {
        this.spaceTemplatFoldersList = response?.data?.spaceTemplateFolders
        this.spaceTemplatFoldersTotal = response?.data?.total || 0
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.spaceFoldersLoader = false
    }
  }

  @action.bound
  addSpaceTemplateFolder = async (values) => {
    try {
      let response = await this.post(
        API_ENDPOINTS.ADD_FOLDER_SPACE_TEMPLATE,
        values
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addSpaceTemplateFolderLocally = async (values) => {
    this.spaceTemplatFoldersList = [values, ...this.spaceTemplatFoldersList]
    if (this.spaceTemplatFoldersList.length > 10) {
      this.spaceTemplatFoldersList.pop()
    }
    this.spaceTemplatFoldersTotal++
  }

  @action.bound
  updateSpaceTemplateFolder = async (values) => {
    try {
      this.spaceTemplateFolderActionLoader = true
      let response = await this.post(
        API_ENDPOINTS.UPDATE_FOLDER_SPACE_TEMPLATE,
        values
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.spaceTemplateFolderActionLoader = false
    }
  }

  @action.bound
  updateSpaceTemplateFolderLocally = async (id, values) => {
    this.spaceTemplatFoldersList = (this.spaceTemplatFoldersList || []).map(
      (folder) => {
        if (folder.id === id) {
          return values
        } else {
          return folder
        }
      }
    )
  }

  @action.bound
  deleteSpaceTemplateFolder = async (data = {}) => {
    try {
      this.spaceTemplateFolderActionLoader = true
      let response = await this.post(
        API_ENDPOINTS.DELETE_FOLDER_SPACE_TEMPLATE,
        data
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.spaceTemplateFolderActionLoader = false
    }
  }

  @action.bound
  moveSpaceFolderByFolderId = async (folderId = undefined, data = {}) => {
    try {
      let options = data
      this.moveSpaceFolderByFIdLoader = true
      options['spaceTemplateFolderId'] = folderId
      let response = await this.post(API_ENDPOINTS.EDIT_SPACE_TEMPLATE, options)
      if (response.status) {
        return [true, response.status]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.moveSpaceFolderByFIdLoader = false
    }
  }

  @action.bound
  setSpaceTemplateSearchText = (value = '') => {
    this.spaceTemplateSearchText = value
  }

  getSpaceTemplatesFilter = () => {
    let temp = {}
    this.spaceTemplateSearchText &&
      (temp['search'] = this.spaceTemplateSearchText)
    return temp
  }

  @action.bound
  getAllSpaceTemplates = async (fId, signal) => {
    try {
      this.spaceTemplatesLoader = true
      let options = this.getSpaceTemplatesFilter()
      options['spaceTemplateFolderId'] = fId
      let response = await this.get(
        API_ENDPOINTS.SPACE_TEMPLATES_LIST,
        {
          ...options,
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        let responseData = response?.data?.spaceTemplates || []
        this.spaceTemplatesTotal = response?.data?.total
        this.spaceTemplates = responseData
        return [true, responseData]
      }
      return [false, unescape]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.spaceTemplatesLoader = false
    }
  }

  @action.bound
  getAllSpaceTemplatesExport = async (values) => {
    try {
      let options = this.getSpaceTemplatesFilter()
      let response = await this.get(API_ENDPOINTS.SPACE_TEMPLATES_LIST_EXPORT, {
        ...values,
        ...options,
        pageLimit: 0,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  locallyAddSpaceTemplate = (spaceTemplate = {}) => {
    if (spaceTemplate?.id) {
      this.spaceTemplates = [...this.spaceTemplates, spaceTemplate]
    }
  }

  @action.bound
  addSpaceTemplate = async (values = {}) => {
    try {
      this.addSpaceTemplateLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_SPACE_TEMPLATE, values)
      if (response.status) {
        this.spaceTemplatesTotal = Math.max(this.spaceTemplatesTotal + 1, 0)
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addSpaceTemplateLoader = false
    }
  }

  @action.bound
  locallyDeleteSpaceTemplate = (id) => {
    if (id) {
      this.spaceTemplates = (this.spaceTemplates || []).filter(
        (spaceTemplate) => spaceTemplate?.id !== id
      )
    }
  }

  @action.bound
  deleteSpaceTemplate = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_SPACE_TEMPLATE, {
        id,
      })
      if (response.status) {
        this.spaceTemplatesTotal = Math.max(this.spaceTemplatesTotal - 1, 0)
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  locallyUpdateTemplate = (id, values) => {
    if (id && values?.id) {
      this.spaceTemplates = (this.spaceTemplates || []).map((spaceTemplate) => {
        if (id === spaceTemplate?.id) {
          return values
        } else {
          return spaceTemplate
        }
      })
    }
  }

  @action.bound
  updateSpaceTemplate = async (id, values) => {
    try {
      this.addSpaceTemplateLoader = true
      let response = await this.post(API_ENDPOINTS.EDIT_SPACE_TEMPLATE, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addSpaceTemplateLoader = false
    }
  }

  // Import task template
  @action.bound
  importSpaceTempFromFile = async (values) => {
    try {
      this.importSpaceTempFromFileLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.IMPORT_SPACE_TEMP_FROM_FILE,
        formDataValues
      )
      if (response.status) {
        this.importSpaceTemp = response.data || []
        this.importSpaceTempFailures =
          {
            headerMessage: response?.message || '',
            failedErrors: response.data?.failures || [],
            fileUpload: response.status,
            isError: true,
          } || []
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      if (err?.error?.statusCode === ERROR_CODE?.MENUAL_CODE) {
        this.importSpaceTempFailures =
          {
            headerMessage: err?.message,
            failedErrors: null,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      } else {
        this.importSpaceTempFailures =
          {
            headerMessage: err?.message,
            failedErrors: err?.error,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      }
    } finally {
      this.importSpaceTempFromFileLoader = false
    }
  }

  @action.bound
  importSpaceTempFromFileReset = async () => {
    this.importSpaceTemp = []
    this.importSpaceTempFailures = []
  }

  @action.bound
  resetStore = () => {
    this.spaceTemplatesLoader = false
    this.spaceTemplates = []
    this.spaceTemplatesTotal = 0
    this.spaceTemplateLoader = false

    this.spaceTemplateFoldersDropdownList = []
    this.spaceTemplateDropdownList = []
    this.spaceTemplatFoldersSearchText = ''
    this.spaceFoldersLoader = false
    this.spaceTemplatFoldersCurrentPage = DEFAULT_PAGE_START
    this.spaceTemplatFoldersList = []
    this.spaceTemplatFoldersTotal = 0
    this.spaceTemplateFolderActionLoader = false
    this.moveSpaceFolderByFIdLoader = false

    this.spaceTemplateSearchText = ''
    this.addSpaceTemplateLoader = false

    this.importSpaceTemp = []
    this.importSpaceTempFailures = []
    this.importSpaceTempFromFileLoader = false
  }
}
